import React from 'react';
import { useSession } from '../Session';
import { classNames, useFlipFlop } from '../../Services/helpers';
import Icon from '../Icons/Icon';
import { useAssistantContext } from './Provider';
import Content from './Content';

const DesktopPanel = () => {
    const {isAdminSwitched} = useSession();
    const {assistantOpen, setAssistantOpen, unseen} = useAssistantContext();
    const bounce = useFlipFlop(2000, 10000);

    if (isAdminSwitched) {
        return null;
    }

    return <div
        className={classNames(
            'absolute bottom-4 right-4 z-50',
            'border border-brand rounded-lg shadow-lg',
            'flex flex-col p-0',
            'transition-all duration-300 ease-in-out',
            'w-full',
            assistantOpen && 'overflow-hidden',
            (!assistantOpen && unseen && bounce) && 'animate__animated animate__bounce',
            assistantOpen ? 'bg-linear-to-br from-sky-50/60 to-white/60 dark:from-sky-800/60 dark:to-black/60 bg-opacity-50 backdrop-blur-md' : 'bg-white dark:bg-black/95',
            !assistantOpen && 'bg-white/95 dark:bg-black/95',
            !assistantOpen && 'hover:shadow-lg hover:shadow-brand hover:bg-sky-50',
            assistantOpen ? 'max-w-[400px] h-[50vh]' : 'max-w-14 h-14',
        )}
    >
        {assistantOpen ? <Inner {...{setAssistantOpen}} /> : <Button {...{setAssistantOpen, unseen}} />}
    </div>
}

const Button = ({setAssistantOpen, unseen}) => {
    const {showDarkMode} = useSession();

    return <button
        className="w-full h-full flex items-center justify-center"
        onClick={() => setAssistantOpen(true)}
    >
        <Icon theme="soapy"
            icon={showDarkMode ? "SidLightDark" : "SidLight"}
            size="3x"
            badge={unseen}
            className="mb-1"
        />
    </button>
}

const Inner = ({setAssistantOpen}) => {
    const {showDarkMode} = useSession();

    return <>
        <p className={classNames(
                'pt-2 pb-1 px-4 w-full text-center bg-white/25 dark:bg-black/25',
                'text-brand fill-brand hover:bg-sky-50 dark:hover:bg-sky-900 cursor-pointer',
                'border-b border-gray-200',
                'text-lg font-bold',
            )}
            onClick={() => setAssistantOpen(false)}
        >
            <span className="align-top">Sid</span>
            <Icon theme="soapy"
                icon={showDarkMode ? "SidSolidDark" : "SidSolid"}
                size="2x"
                className="fill-light float-end"
            />
        </p>

        <div className="flex-1 min-h-0">
            <Content />
        </div>
    </>
}

export default DesktopPanel;
